<template>
  <v-container>
    <v-data-table :headers="headers" :items="items" class="elevation-0" disable-pagination hide-default-footer>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="text-align: left">{{ props.item.resource }}</td>
          <td style="text-align: left">{{ props.item.equipmentStatusName }}</td>
          <td style="text-align: left">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-divider class="mb-3"></v-divider>
  </v-container>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from "vuex";

  export default {
    name: "equipment-status",
    data() {
      return {
        headers: [
          {
            text: this.$t("vessel.resource"),
            align: "start",
            value: "resource",
          },
          { text: this.$t("vessel.status"), value: "equipmentStatusId" },
          { text: this.$t("vessel.comments"), value: "comments" },
        ],

        currentPVId: null,
        currentMainDprId: null,
      };
    },
    computed: {
      ...mapGetters([
        "mv_dprData/getDprPVId",
        "mv_dprData/getCurrentDprMainId",
        "mv_vesselEquipmentStatus/getEquipmentStatuses",
        "mv_vesselEquipmentStatus/getStatuses",
      ]),
      items() {
        return this["mv_vesselEquipmentStatus/getEquipmentStatuses"];
      },

      statuses() {
        return this["mv_vesselEquipmentStatus/getStatuses"];
      },
    },
    created() {
      this.currentMainDprId = this.$route.params.dprMainId;
      this.currentPVId = this.$route.params.pvId;
      this.refreshEquipmentStatus();

      this["mv_vesselEquipmentStatus/fetchEquipmentStatuses"](this.currentPVId);
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
    filters: {
      statusName: (id, map) => (id ? map[id] : ""),
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "mv_vesselEquipmentStatus/fetchEquipmentStatusByDprId",
        "mv_vesselEquipmentStatus/fetchEquipmentStatuses"
      ]),

      refreshEquipmentStatus() {
        this["mv_vesselEquipmentStatus/fetchEquipmentStatusByDprId"](
          this.currentMainDprId
        );
      }
    },
  };
</script>
<style scoped>
  .container {
    max-width: 95%;
  }
</style>
